<template>
	<div class="title_box box_h">
		<img :src="logoImgUrl" alt="" class="title_logo" />
		<!-- 往期中奖号码 -->
		<div class="numberOpen_box">
			<h3>
				第<span> {{ LastLssue }} </span>期 开奖号码
			</h3>
			<div>
				<slot />
			</div>
		</div>
		<div class="countdown_box">
			<h3>
				第<span> {{ NowLssue }} </span>期 投注倒数计时
			</h3>
			<div>
				<countDown :time="time" @upTimeData="$emit('upTimeData')" />
			</div>
		</div>
		<div class="title-operation box_h">
			<favorite :LgId="GameIds" :GameName="GameName" />
		</div>
	</div>
</template>

<script>
import countDown from "@/components/common/countDown.vue";
import openNumber from "@/components/common/openNumber.vue";
import favorite from "@/components/common/favorite.vue";
export default {
	components: { countDown, openNumber, favorite },
	props: ["LastLssue", "NowLssue", "GameIds", "logoImgUrl", "time", "GameName"],
};
</script>

<style lang="scss" scoped>
.numberOpen_box {
	z-index: 1;
	position: absolute;
	top: 10px;
	left: 190px;
	width: 520px;
	display: flex;
	flex-direction: column;
	align-items: center;
	h3 {
		font-family: PingFangSC;
		font-size: 15px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: left;
		color: #fff;
		margin-bottom: 20px;
		span {
			color: #fff;
		}
	}
}

.countdown_box {
	position: absolute;
	top: 25px;
	right: 170px;

	h3 {
		font-family: PingFangSC;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: center;
		color: #fff;
		span {
			color: #fff;
		}
	}
}

.mark_six {
	.countdown_box {
		right: 155px;
	}
}

.lowLotteryClass {
	.countdown_box {
		right: 143px;
	}
}

.count__time__box {
	span {
		font-family: "LiquidCrystal-Bold";
		font-size: 53.5px;
		color: #1483d1;
	}

	b {
		display: inline-block;
		font-size: 53.5px;
		font-weight: bold;
		color: #1483d1;
		margin: -15px 8px 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/gamePanelTitle.vue